import { useEffect } from 'react'
import { useLocation } from 'react-router'
import PropTypes from 'prop-types'

const ScrollToTop = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return null
}

ScrollToTop.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
}

export default ScrollToTop
